<template>
  <div>
    <div class="title">
      <div class="title--newFont">基本合同</div>
      <div style="text-align: right">
        <el-button type="primary" v-if="homeState == 0" size="mini" @click="getList()"
          >刷新</el-button
        >
        <el-button type="primary" v-if="homeState == 0" size="mini" @click="updateClick()"
          >修改</el-button
        >
        <el-button v-if="homeState == 1" type="primary" size="mini" @click="saveClick()"
          >提交审核</el-button
        >
        <el-button v-if="homeState == 1" type="info" size="mini" @click="closeClick()"
          >取消</el-button
        >
      </div>
    </div>
    <hr />
    <!-- 查看状态 -->
    <div v-if="homeState == 0">
      <div class="titleSpan">其他合同</div>
      <div style="margin: 20px 0px; border: 1px dotted #ccc; padding: 20px">
        <myUploadTable :maxHeight="500" :list="dialogFileListData" :type="3" :status="1">
        </myUploadTable>
      </div>
      <hr />
      <myHtml
        :maxHeight="this.$root.tableHeight - 50"
        :id="'bill_one'"
        :columnType="'columnIndex'"
        :list="list"
        :titleList="titleList"
        :tableBtnList="['取消']"
        @btnClick="btnClick"
        ref="myTable"
      ></myHtml>
    </div>
    <!-- 编辑状态 -->
    <div v-if="homeState == 1">
      <div class="titleSpan">其他合同</div>
      <div style="margin: 20px 0px; border: 1px dotted #ccc; padding: 20px">
        <el-upload
          class="upload-demo"
          :action="url"
          :headers="headers"
          name="uploadFile"
          :data="{
            asImage: false,
            fieldName: fieldName,
            model: '协同供应商',
          }"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :on-success="fileSuccess"
          :on-remove="fileRemove"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">点击上传对应文件。</div>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import {
  supplier_view,
  pmgtCooperateDraftDoc_list,
  pmgtCooperateDraftDoc_add,
  pmgtCooperateDraftDoc_delete,
} from "@/api/myController/purchase";
import { getCurrentTime } from "@/utils/myUtils";
import projectConfig from "@/core/config";
import { getToken } from "@/utils";
export default {
  name: "supplier_contract",
  data() {
    return {
      url: projectConfig.baseUrl + "qingguang/cooperativesupplier/common/uploadDoc",
      showImageUrl: projectConfig.imageBaseUrl, // 显示图片路径
      // 文件
      fieldName: "",
      fileList: [],
      dialogFileListData: [],
      singleData: {},
      updateData: {},
      homeState: 0,
      //
      list: [],
      titleList: [
        {
          id: 11,
          name: "标题",
          value: "cooperateDraftTitle",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 11,
          name: "修改类型",
          value: "checkType",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
        },
        {
          id: 9,
          name: "执行状态",
          value: "statusExecution",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已执行",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未执行",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
        },
        {
          id: 9,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
        },
        {
          id: 11,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      supplier_view({ supplierId: this.getUserInfo.supplierId }).then((res) => {
        this.singleData = res.data.data;
        this.fileList = [];
        // 文件处理
        try {
          this.dialogFileListData = JSON.parse(this.singleData.baseFileList);
          this.dialogFileListData.forEach((item) => {
            this.fileList.push({
              name: item.name,
              url:
                item.url.indexOf("http") >= 0 ? item.url : this.showImageUrl + item.url,
            });
          });
        } catch (error) {}
      });
      pmgtCooperateDraftDoc_list({
        pmgtCooperateDraftDocDtoFilter: {
          checkType: "基本合同",
        },
      }).then((res) => {
        this.list = res.data.data.dataList;
      });
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "取消":
          if (row.statusCheck == 0) {
            this.$confirm("确定取消？, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                pmgtCooperateDraftDoc_delete({
                  cooperateDraftDocId: row.cooperateDraftDocId,
                }).then((res) => {
                  this.$message.success("操作成功！");
                  this.getList();
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          } else {
            this.$message({
              type: "info",
              message: "已审核状态不能进行取消！",
            });
          }
          break;
        default:
          break;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 文件
    fileRemove(res, file) {
      this.dialogFileListData = [];
      file.forEach((item) => {
        if (item.response) {
          this.dialogFileListData.push({
            name: item.name,
            url: item.response.data.uploadPath + item.response.data.filename,
          });
        } else {
          this.dialogFileListData.push({
            name: item.name,
            url: item.url.replace(this.showImageUrl, ""),
          });
        }
      });
    },
    fileSuccess(res, file) {
      this.dialogFileListData.push({
        fileInfoId: res.data.fileInfoId,
        name: file.name,
        url: res.data.uploadPath + res.data.filename,
        createTime: getCurrentTime(),
        createName: this.getUserInfo.showName,
      });
    },
    updateClick() {
      this.updateData = JSON.parse(JSON.stringify(this.singleData));
      this.homeState = 1;
    },
    // 修改提交
    saveClick() {
      this.getList();
      this.homeState = 0;
      return;
      let json = {
        cooperateDraftTitle: "基本合同修改-" + getCurrentTime(),
        checkType: "基本合同",
        cooperateDraftDataDomain: JSON.stringify(this.updateData),
        supplierId: this.getUserInfo.supplierId,
        presenterId: this.getUserInfo.supplierId,
        presenterName: this.getUserInfo.showName,
        supplierName: this.getUserInfo.showName,
        supplierNumber: this.getUserInfo.supplierNumber,
        statusExecution: 0,
        statusCheck: 0,
        scheduleDocTime: getCurrentTime(),
      };
      pmgtCooperateDraftDoc_add({ pmgtCooperateDraftDocDto: json }).then((res) => {
        this.$message.success("操作成功！");
        this.getList();
        this.homeState = 0;
      });
    },
    // 取消
    closeClick() {
      this.homeState = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.titleSpan {
  color: #005ca3;
  font-size: 18px;
  border-left: 4px solid #005ca3;
  font-weight: 800;
  padding-left: 20px;
}
</style>
